import React from "react";
import ReadIcon from "../../img/user-mail.png";

export const UserIconMailView = (props) => {
  const imgclassName = props?.className ? props?.className : "df-w-42";

  return (
    <>
      <img src={ReadIcon} className={imgclassName} />
    </>
  );
};
